import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { General, Widgets } from "../../../utils/Constant";
import BitcoinCurrency from "./BitcoinCurrency/BitcoinCurrency";
import PurchaseWidget from "./PurchaseWidget/PurchaseWidget";
import CompletedCourses from "./CompletedCourses/CompletedCourses";
import TotalUsers from "./TotalUsers/TotalUsers";
import Visitors from "./Visitors/Visitors";
import SocialIcon from "./SocialIcon/SocialIcon";
import NewOrders from "./NewOrders/NewOrders";
import YourBalance from "./YourBalance/YourBalance";
import DatePicker from "./DatePicker/DatePicker";
import AverageSales from "./AverageSales/AverageSales";

const ContainerGeneral = () => {
  return (
    <>
      <Breadcrumbs mainTitle={General} parent={Widgets} />
      <Container fluid className="widget-page">
        <Row>
          <BitcoinCurrency />
          <AverageSales />
          <PurchaseWidget />
          <CompletedCourses />
          <TotalUsers />
          <Visitors />
          <SocialIcon />
          <NewOrders />
          <YourBalance />
          <DatePicker />
        </Row>
      </Container>
    </>
  );
};

export default ContainerGeneral;
